var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

// eslint-disable-next-line no-restricted-imports

import { LaunchDarklyProject } from '@square/ember-features/protos/squareup/feature/relay/flags/message/launch_darkly_project';
import { DataType } from '@square/ember-features/protos/squareup/feature/relay/common/data_type';
import { createGiftingEligibleUrl } from '@square/dashboard-items-data/utils/sites/weebly';
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import { getCookie } from '@square/dashboard-utilities/utils/cookies';
export let Feature = /*#__PURE__*/function (Feature) {
  Feature[Feature["ADVANCED_CATEGORIES_BETA"] = 1] = "ADVANCED_CATEGORIES_BETA";
  return Feature;
}({});
export const PREORDERING_FEATURE_KEY = 'ecom_preorders';
export const MODIFIER_IMAGES_FEATURE_KEY = 'modifier_images';
export const GIFTING_OPTION_FEATURE_KEY = 'com_gifting';
export const ORDER_ITEM_QUANTITY_LIMIT_FEATURE_KEY = 'order_item_quantity_limit';
export const SCHEDULED_ACTIONS_FEATURE_KEY = 'product_scheduled_actions';
const LAUNCH_DARKLY_FEATURE_FLAGS = [{
  flagName: 'catalog/item_gifting_enabled',
  project: LaunchDarklyProject.PIE,
  type: DataType.BOOLEAN
}];
let CatalogFeatures = (_dec = service('chamber/chamber-ajax'), _class = class CatalogFeatures extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "catalogSentry", _descriptor, this);
    _initializerDefineProperty(this, "chamberService", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _initializerDefineProperty(this, "userInfo", _descriptor4, this);
    _initializerDefineProperty(this, "weeblyUserData", _descriptor5, this);
    _initializerDefineProperty(this, "hasStartedInitialization", _descriptor6, this);
    _initializerDefineProperty(this, "hasFailedEligibilityRequest", _descriptor7, this);
    _initializerDefineProperty(this, "hasFetchedGiftingEligibilitySuccessfully", _descriptor8, this);
    _initializerDefineProperty(this, "hasInitiallyLoadedFlags", _descriptor9, this);
    _initializerDefineProperty(this, "isEligibleToSeeGiftingOptionRow", _descriptor10, this);
  }
  /**
   * Gets values for Catalog flags
   * @param reload - reload all flag values
   */
  async initialize(reload = false) {
    if (!this.hasStartedInitialization && !this.hasInitiallyLoadedFlags || reload) {
      this.hasStartedInitialization = true;
      try {
        await this.weeblyUserData.loadWeeblyData({
          fetchStoreData: false
        });
      } catch (errors) {
        this.catalogSentry.withScope(scope => {
          scope.setExtra('errors', errors);
          scope.setLevel('warning');
          this.catalogSentry.captureMessage('Error while loading Weebly user data');
        });
      }
      try {
        await this.getLDValues({
          setFlags: true
        });
        this.hasInitiallyLoadedFlags = true;
      } catch (errors) {
        this.catalogSentry.withScope(scope => {
          scope.setExtra('errors', errors);
          scope.setLevel('warning');
          this.catalogSentry.captureMessage('Error while loading LD flags');
        });
      }
      this.hasStartedInitialization = false;
    }
  }

  // already existing square online seller before advanced categories M1
  get isSoUserWithLimitedAdvancedCategories() {
    if (this.weeblyUserData.hasSquareOnlineFetchError) {
      // we cannot determine seller status for non-404 errors, so assume is Square Online for categories use cases
      return true;
    }
    const weeblyUserInfo = this.weeblyUserData.getProperty('weeblyUserInfo');
    return weeblyUserInfo && !weeblyUserInfo.dtc_only && weeblyUserInfo.uses_advanced_categories === false;
  }
  get isSoUserWithAdvancedCategories() {
    return this.weeblyUserData.getProperty('isWeeblyUser') && !this.isSoUserWithLimitedAdvancedCategories;
  }
  get isEligibleForItemGifting() {
    return this.weeblyUserData.getProperty('isWeeblyUser') && this.isEligibleToSeeGiftingOptionRow && this.features.isEnabled('catalog/item_gifting_enabled');
  }
  async getLDValues(options) {
    const attributes = {
      country: this.userInfo.countryCode,
      platform: 'web',
      product: 'dashboard',
      locale: window.navigator.language.split('-')[0],
      'ecom.is_square_online': true,
      'ecom.adv_cat_m3_cohort': this.weeblyUserData.weeblyUserInfo?.advanced_categories_migration_cohort ?? ''
    };
    const evaluatedFlags = await this.features.evaluate(LAUNCH_DARKLY_FEATURE_FLAGS, this.userInfo.merchantToken, attributes, options.setFlags);
    return evaluatedFlags;
  }
  async loadGiftingEligibility(reload = false) {
    try {
      if (this.features.isEnabled('catalog/item_gifting_enabled') && this.weeblyUserData.getProperty('isWeeblyUser') && (!this.hasFetchedGiftingEligibilitySuccessfully || reload)) {
        const response = await jsonPost(createGiftingEligibleUrl(), {
          headers: {
            'X-CSRF-Token': getCookie('_js_csrf')
          }
        });
        this.isEligibleToSeeGiftingOptionRow = response.response.data.is_eligible;
        this.hasFetchedGiftingEligibilitySuccessfully = true;
      }
    } catch (errors) {
      this.hasFailedEligibilityRequest = true;
      this.catalogSentry.withScope(scope => {
        scope.setExtra('errors', errors);
        scope.setLevel('warning');
        this.catalogSentry.captureMessage('Error while fetching seller gifting eligibility');
      });
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "catalogSentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "chamberService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "weeblyUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasStartedInitialization", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasFailedEligibilityRequest", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hasFetchedGiftingEligibilitySuccessfully", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hasInitiallyLoadedFlags", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isEligibleToSeeGiftingOptionRow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { CatalogFeatures as default };